<template>
    <div class="">
        <div class="modal fade" id="loginMoblizer" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body login-mobilizer text-left p-4">
                        <div class="login-mobilizer-inner p-5">
                            <img class="logo mb-3" src="/images/simsim-logo-colored.png" alt="" />
                            <div class="moblizer-account-login">
                                <span class="title mb-2"> Sign in to your corporate <span class="highlight-color">SimSim</span> Account </span>
                                <div class="form-group mb-2">
                                    <input v-model="form.username" readonly type="text" class="form-control" name="username" :class="{ 'is-invalid': form.errors.has('username') }" />
                                    <has-error :form="form" field="username"></has-error>
                                </div>
                                <div class="form-group mb-2">
                                    <input v-model="form.password" type="password" name="password" class="form-control" placeholder="Password" :class="{ 'is-invalid': form.errors.has('password') }" />
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <span class="title mb-2"> Do you really want to proceed? </span>
                                <div class="row normal-ib-space">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                    <div class="col"> <button class="btn btn-primary proceed active" @click="proceedLogin"> Proceed </button> </div>
                                </div>
                            </div>
                            <div class="moblizer-account-detail hide">
                                <label class="label block-label"> Name </label>
                                <div class="form-group mb-2">
                                    <input v-model="processForm.customerName" type="text" class="form-control" readonly="" />
                                </div>
                                <label class="label block-label"> IBAN </label>
                                <div class="form-group mb-2">
                                    <input type="text" class="form-control" readonly=""  v-model="processForm.iBAN" />
                                </div>
                                <label class="label block-label"> Balance </label>
                                <div class="form-group mb-2">
                                    <input type="text" class="form-control" readonly="" v-model="processForm.balance" />
                                </div>
                                <label class="label block-label"> Core Linked account </label>
                                <div class="form-group mb-2">
                                    <input type="text" class="form-control" readonly="" v-model="processForm.paymentInstrumentBankAccountNumber"/>
                                </div>
                                <div class="row normal-ib-space mt-3">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" @click="cancelMobilizer"> Cancel </button> </div>
                                    <div class="col"> <button :disabled="processForm.busy" class="btn btn-primary active" @click="processPayments"> Proceed </button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        props:['billIds','paymentType','payroll_id','topup_id','payrollTotalAmount','loginDetails', 'payableTxnAmount'],

        data() {
            return {
                form: new Form({
                    username : this.$global.user_company_email,
                    password : '',
                }),
                processForm : new Form({
                    customerName            : '',
                    iBAN                    : '',
                    balance                 : '',
                    Cookie                  : '',
                    sessionId               : '',
                    paymentInstrumentBankAccountNumber  : '',
                    paymentInstrumentIdSVA  : '',
                    customerId              : '',
                    billIds                 : this.billIds,
                    payroll_id              : this.payroll_id,
                    topup_id                : this.topup_id,
                    paymentReprocess         : false,
                }),
                processButton : false,
            };
        },
        mounted() {
            setTimeout(()=>{
                if(this.loginDetails !== null || this.loginDetails !==''){
                    var pass = atob(this.loginDetails.password);
                    this.form.password = pass;
                }
            }, 300);
            // EventBus.$on('paymentReprocess', data => {
            //    this.processForm.paymentReprocess = data;
            // });
        },
        methods:{
            proceedLogin: function(){
                if(this.form.username == '' || this.form.password == ''){
                    this.showToastBox('error','Please enter the credentials!');
                    return;
                }
                switch (this.paymentType) {
                    case 'bill_payment':
                        this.corpLoginForBill();return;
                    case 'employee_payment':
                        this.corpLoginForPayments();return;
                    case 'topup_payment':
                       this.corpLoginForTopup();return;
                    case 'vendor_payment':
                       this.corpLoginForVendor();return;
                    case 'pms_membership_payment':
                       this.corpLoginForPms();return;
                }
            },
            corpLoginForBill: function () {
                this.$Progress.start();
                this.form.post('/api/corpLoginForBill')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if (res.data.status == '200'){
                                this.showToastBox('success','Please proceed your bill payment.');
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                if(res.data.data.balance >= this.payableTxnAmount) this.processButton = true;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');

                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            corpLoginForPayments: function () {
                this.$Progress.start();
                this.form.post('/api/processBatch')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed your batch.');
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                if(res.data.data.balance >= this.payableTxnAmount) this.processButton = true;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },
            corpLoginForTopup: function () {
                this.$Progress.start();
                this.form.post('/api/corpLoginForTopup')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed your batch.');
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                if(res.data.data.balance >= this.payableTxnAmount) this.processButton = true;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },
            corpLoginForVendor: function () {
                this.$Progress.start();
                this.form.post('/api/corpLoginForVendor')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed your batch.');
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                if(res.data.data.balance >= this.payableTxnAmount) this.processButton = true;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },
            corpLoginForPms: function () {
                this.$Progress.start();

                this.form.post('/api/pms/corpLoginForPms')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if(res.data.status == 200){
                                this.showToastBox('success','Please proceed with your payment.');
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.sessionId = res.data.data.sessionId;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                if(res.data.data.balance >= 0) this.processButton = true;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showToastBox('error', res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showToastBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showToastBox('error','Some problem in your form data');
                    });
            },

            processPayments: function(){

                switch (this.paymentType) {
                    case 'bill_payment':
                        this.processBills();return;
                    case 'employee_payment':
                        this.processEmployeePayments();return;
                    case 'topup_payment':
                        this.processTopupPayments();return;
                    case 'vendor_payment':
                        this.processVendorPayments();return;
                    case 'pms_membership_payment':
                        this.processPmsPayments();return;
                }
            },
            processBills: function(){
                this.$Progress.start();
                this.processForm.post('/api/billSendForPayment')
                    .then(res => {
                        if(res.status == 200){
                            // $('#dt-new').DataTable().ajax.reload();
                            this.$Progress.finish();
                            $('#loginMoblizer').modal('hide');
                            this.$router.push('/billPayments');
                            this.showToastBox('success','Bill proceed successfully');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processEmployeePayments: function(){
                this.$Progress.start();
                this.processForm.post('/api/proceedBatchQueue')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            $('#loginMoblizer').modal('hide');
                            this.$router.push('/employeePayments');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processVendorPayments: function(){
                this.$Progress.start();
                this.processForm.post('/api/VendorSendForPayment')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            $('#loginMoblizer').modal('hide');
                            this.$router.push('/vendorPayment');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processTopupPayments: function(){
                this.$Progress.start();
                this.processForm.post('/api/proceedTopupQueue')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            $('#loginMoblizer').modal('hide');
                            this.$router.push('/topupsPayments');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            processPmsPayments: function(){
                this.$Progress.start();

                this.showToastBox('success', 'Success');
                $('#loginMoblizer').modal('hide');

                this.$emit('corpLoginSuccess', {
                    bank: 'finca',
                    data: this.processForm
                });

                this.$Progress.finish();

                return true;
            },

            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
        },
        destroyed: function() {
            // EventBus.$off('paymentReprocess');
        },

    }
</script>
